import * as React from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { RoleNames } from 'shared/models/Enum'
import ProtectedNavDropdownItem from './ProtectedNavDropdownItem'
import { Link } from 'react-router-dom'

export default function TopMenu() {
  return (
    <Navbar bg='light' expand='lg' sticky='top'>
      <Navbar.Brand href='#home'>LBO</Navbar.Brand>
      <Navbar.Toggle aria-controls='basic-navbar-nav' />
      <Navbar.Collapse id='basic-navbar-nav'>
        <Nav className='mr-auto'>
          <Nav.Link as={Link} to='/home'>
            Home
          </Nav.Link>
          <NavDropdown title='Locaties' id='basic-nav-dropdown'>
            <ProtectedNavDropdownItem
              to='/afleverlocatiesklanten'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Afleverlocaties Klanten
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/koppelingenvestigingen'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Gekoppelde adressen per vestiging
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/locatiesvestigingen'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              GLN-locaties per vestiging
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/zoekklantlocatiekoppelingen'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Zoek klant-locatie koppelingen
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/geenkoppeling'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Kopers zonder gekoppelde locatie(s)
            </ProtectedNavDropdownItem>
          </NavDropdown>
          <NavDropdown title='Tijdvakken' id='basic-nav-dropdown'>
            <ProtectedNavDropdownItem
              to='/tijdvakkenOnderhouden'
              requiredRole={RoleNames.LboKlantGroepenOnderhouden}
            >
              Tijdvakken Onderhouden
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/tijdvakkenKoppelen'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Tijdvakken Koppelen
            </ProtectedNavDropdownItem>
          </NavDropdown>
          <NavDropdown title='Volumewaarden' id='basic-nav-dropdown'>
            <ProtectedNavDropdownItem
              to='/volumewaarden'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Volumewaarden Onderhouden
            </ProtectedNavDropdownItem>
            <ProtectedNavDropdownItem
              to='/productafmetingen'
              requiredRole={RoleNames.LboGlnOnderhouden}
            >
              Productafmetingen Onderhouden
            </ProtectedNavDropdownItem>
          </NavDropdown>
          <NavDropdown title='Overig' id='basic-nav-dropdown'>
            <NavDropdown.Item as={Link} to='/about'>
              About
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}
